<template>
  <div>
    <MButton v-bind="getBindValue" @click="openImport">
      <slot>{{ t('common.import') }}</slot>
    </MButton>

    <AsyncImportModal
      v-bind="pick(props, IMPORT_PROP_KEYS)"
      @register="registerModal"
      @ok="importDone"
    >
      <template v-for="item in Object.keys($slots)" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </AsyncImportModal>
  </div>
</template>

<script setup lang="ts">
  import { ComponentOptionsMixin, computed, unref } from 'vue';
  import { useAttrs } from '@mts-fe/hooks';
  import { omit, pick } from '@mts-fe/utils';
  import { MButton, MButtonProps } from '@mts/components/Button';
  import { ModalProps, useModal } from '@mts/components/Modal';
  import { t } from '@mts/hooks/web/useI18n';
  import type { ImportProps } from '..';
  import AsyncImportModal from './AsyncImportModal.vue';

  /** 异步弹窗导入-按钮 */
  defineOptions({
    name: 'AsyncImportBtn',
    extends: MButton as ComponentOptionsMixin,
    inheritAttrs: false,
  });

  export type ModalImportProps = MButtonProps &
    ImportProps & {
      /** 弹窗配置 */
      modal?: ModalProps;
    };

  const IMPORT_PROP_KEYS = ['action', 'params', 'template'];
  const props = withDefaults(defineProps<ModalImportProps>(), {
    template: () => ({}),
  });
  const attrs = useAttrs();
  const getBindValue = computed(() => ({
    ...unref(attrs),
    ...omit(props, [...IMPORT_PROP_KEYS, 'modal']),
  }));

  const [registerModal, modalAction] = useModal();
  const openImport = () => {
    modalAction.setModalProps({ ...props.modal });
    modalAction.openModal(true);
  };

  const emit = defineEmits(['ok']);
  const importDone = (...args) => emit('ok', ...args);
</script>
